export default __webpack_public_path__ + "a546c64c7fb1acf9767637876bcd6331.svg";